import { useFeatureIsOn } from "@growthbook/growthbook-react";
import { useRouter } from "next/router";
import { CloudinaryImage } from "../../../../Atoms/Cloudinary";
import styles from "./InfluencerRecommendation.module.scss";

function InfluencerRecommendation() {
  const router = useRouter();
  const { utm_source, id } = router?.query;
  const isAbOn = useFeatureIsOn("product-influencer-recommendation");
  if (
    utm_source &&
    utm_source === "TheInvisibleTourist" &&
    isAbOn &&
    getRecommendationTextMap[id as string]
  ) {
    const recommendText = getRecommendationTextMap[id as string];

    return (
      <div>
        <UserProfile
          profileImage="https://res.cloudinary.com/dbm1qiew0/image/upload/v1739934268/charter-assets/xbhdx3zqn1tzqeuhjbl8.png"
          recommendationText={recommendText}
        />
      </div>
    );
  }
  return;
}

export default InfluencerRecommendation;

const UserProfile = ({ profileImage, recommendationText }) => {
  return (
    <div className={styles.UserProfileContainer}>
      <div className={`${styles.NeonFrame} ${styles.ProfileImageContainer}`}>
        <CloudinaryImage
          src={profileImage}
          transformations={["w_125", "h_80", "c_fill"]}
        />
      </div>

      <div>
        <div className={styles.AuroraContainer}>
          <b className={styles.AuroraText}>The Invisible Tourist Recommends</b>
        </div>

        <div className={styles.RecommendationText}>{recommendationText}</div>
      </div>
    </div>
  );
};

const getRecommendationTextMap: Record<string, string> = {
  "5375d9fa-7def-4938-b006-b97a44a4bd2e":
    "This tour is honestly the best way to see Fushimi Inari Shrine without having to wake up very early or visit at night. I loved learning about the significance of the summit's smaller shrines, as well as enjoying a hidden bamboo grove - all without the crowds. I can't recommend it enough!",

  "677b1a57-c0a8-43db-a574-45888f4a5fed":
    "I absolutely loved learning the local knowledge of Kiyomizu-dera's features I wouldn't have discovered without MagicalTrip. The tea ceremony with a geiko afterwards was a real treat! I learned all the customs behind the ceremony and had the opportunity to ask the geiko questions afterward. Highly recommended!",

  "e97da2a4-a99c-4ec8-b2c2-e5e9ae25a8f6":
    "What a fun night out! I enjoyed sampling the different Japanese foods at each izakaya and learning more about the flavors of sake that I didn't realize before. This tour will help you blend right in while enjoying local drinking culture. I definitely recommend it!",

  "cd7ede5a-72cb-4204-858a-52be444dc1ff":
    "Finding hidden bars by yourself in Pontocho can feel a little intimidating. It was fantastic to have a local guide take us to their favorite spots and learn about Japanese drinking culture. I sampled a special rare red sake I'd never seen before. I definitely recommend this tour for a fun night out in Kyoto!",
  "59afbefb-b0d9-4e10-9273-b6c59b81e345":
    "As Shinjuku is becoming increasingly popular with tourists, allow MagicalTrip to help you blend in and keep things feeling local on this tour. I'm sure you'll become a fan of izakaya culture, too!",
  "ff345d77-8741-4669-aef1-e0d979c2361f":
    "Enjoy sampling different kinds of sake brewed right here in Kyoto, paired with delicious traditional foods. You local guide will do the ordering and explain each dish, so you can sit back and relax!",
  "4b8953b7-b5d8-46b9-b6b0-3b0f10942a68":
    "Hiroshima is a location everyone should visit in their lifetime if given the chance. To make the most of your visit, uncover a deeper understanding of Hiroshima's attractions through family stories and experiences from a local on this tour. You'll learm more than the average visitor!",
  "2f0f6f2e-1046-4658-8893-fcf0cd2406e5":
    "Parts of the Arashiyama area become overwhelmed with tourist crowds during the day. This tour will help you blend in and bypass the crowds to discover a quiet, more local side of this iconic location most tourists miss!",
  "b0423202-29dd-4399-b047-9c6a0ee31ea5":
    "Nishiki Market features an overwhelming selection of different foods to try. If you're unsure what to eat, MagicalTrip will help steer you towards authentic specialties loved by locals for centuries!",
  "a9a2ebd9-ced6-4793-a0cf-14488d92b03a":
    "Enjoy a fun night out in Osaka! Your MagicalTrip guide will introduce you to their favourite local izakaya spots. This touri is also perfect for vegan and vegetarians, which can sometimes be a struggle in Japan!",
  "763e12a9-ef93-4ae4-8e17-cf86eda92b3f":
    "Eat 'til you drop in Osaka, the Kitchen of Japan! MagicalTrip will help you avoid tourist crowds in Dotonbori while sampling local specialties, before transporting you back in time to the Showa era in retro Shinsekai. Learn what makes each of Osaka's dishes so unique!",
  "e8a26b4b-898e-4e85-bdc2-1fd285dd06ff":
    "Shinjuku is becoming increasingly popular with tourists, so it can be difficult to find local spots. Allow MagicalTrip to help you blend in at hidden sushi, yakiniku and wagyu eateries adored by locals!",
};
